import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPlans } from 'State/Plans/PlansActions';

export const usePlans = (preSelectPlanText = '') => {
  const dispatch = useDispatch();
  const plans = useSelector((s) => s.plans);
  const { getPlansSuccess, isFetchingPlans } = plans;
  useEffect(() => {
    if (!getPlansSuccess && !isFetchingPlans) {
      console.log('ACTION: FETCH_PACKAGES', preSelectPlanText);
      dispatch(getPlans(preSelectPlanText));
    }
  }, [dispatch, getPlansSuccess, isFetchingPlans, preSelectPlanText]);
  return plans;
};
